import fetch from "auth/FetchInterceptor";

const termosUsoService = {};

termosUsoService.obterStatus = async function () {
	return fetch({
		url: "/v1/rpc/status-termos-uso",
		method: "get",
	});
};

termosUsoService.aceitar = async function (versao) {
	return fetch({
		url: "/v1/rpc/aceitar-termos-uso",
		method: "post",
		data: { versao },
	});
};

export default termosUsoService;
